<template>
  <div class='m-t-20'>
    <a-table :pagination='false' rowKey="activity_id" :loading='listLoading' bordered :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}">
      <template #priority>
        <span>
          优先级
          <a-tooltip placement="right" :auto-adjust-overflow="false">
            <template #title>
              <p>优先级数值越大代表优先级越高；若优先级相同，时间越新，优先级越高</p>
            </template>
            <QuestionCircleOutlined />
          </a-tooltip>
        </span>
      </template>
      <template v-slot:priorityContent="{ record }">
        <a-popconfirm @confirm="confirmSetSort(record)" @cancel="initData" class='m-r-10'>
          <template #title>
            <a-input-number v-model:value="record.sort_level" placeholder="优先级" :precision="0" />
          </template>
          <template #icon>
            <span></span>
          </template>
          {{record.sort_level}}
          <FormOutlined />
        </a-popconfirm>
      </template>
      <template v-slot:content="{ record }">
        <a-button type="link" color="blue" @click="$router.push({path:'/marketing/marketingActivity/scan/activityData',query:{activity_id:record.activity_id}})">查看</a-button>
      </template>
      <template v-slot:schedule="{ record }">
        <!-- status="exception" -->
        <a-progress :percent="record.plan" status="active" />
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </div>

</template> 
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { QuestionCircleOutlined, FormOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import {
  activitys,
  activitysTwoDetail,
  activitysTreeList,
} from "@/api/qrcodeActivitys";
import { message } from "ant-design-vue";
const def = {
  page: 1,
  limit: 10,
  status: "2",
  keyword: "",
  code: "",
  batch_sn: "",
  is_open: "",
};
export default {
  name: "integralDetail",
  components: {
    QuestionCircleOutlined,
    FormOutlined,
  },
  setup() {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
      rangeVisible: false,
      awardVisible: false,
      rangeList: [],
      awardList: [],
      awardDetail: {},
      rangeTotal: 0,
      detailVisible: false,
    });
    let data = ref();

    let columns = [
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "时间进度",
        key: "schedule",
        width: 230,
        slots: { customRender: "schedule" },
      },
      {
        title: "活动数据",
        dataIndex: "content",
        key: "content",
        slots: { customRender: "content" },
      },
    ];
    const initData = async (values) => {
      state.listLoading = true;
      let res = await activitys(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref(def);
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
    };
  },
};
</script>